/**
 *
 * @param inputString {String}
 * @typedef {Array} ParsedPermissions
 * @returns {ParsedPermissions}
 */
export function parsePermissionString (inputString) {
	return inputString.split('\n')
		.map((str) => {
			if (str.startsWith('#')) return false;
			const [mode = '', path = ''] = str.split(' ');
			return {
				mode: mode.trim(),
				path: path.split('.')
					.map((e) => e.trim())
			};
		}).filter(Boolean);
}
